import { createContext, ReactNode, useContext } from 'react';

import { VolSurfaceToken } from '../model/currency_type.enum';
import { GetVolContext } from './get-vol-provider';
import { SnapshotTypeEnum } from '../model/snapshot_type';
import { WidgetContext } from '../components/v2/widget-renderer/widget-provider';

interface ModelVolatilitySurfaceProviderProps {
  children: ReactNode;
  providerKey?: string;
}

interface ModelVolatilitySurfaceContextType {
  token: VolSurfaceToken;
  setToken: React.Dispatch<React.SetStateAction<VolSurfaceToken>>;
  data: any;
  timestamp: string;
  isFixedToken: boolean;
}

export const ModelVolatilitySurfaceContext = createContext({} as ModelVolatilitySurfaceContextType);

export const ModelVolatilitySurfaceProvider = (props: ModelVolatilitySurfaceProviderProps) => {
  const { children } = props;
  const type = SnapshotTypeEnum.EE;

  const getVolContext = useContext(GetVolContext);
  const widgetContext = useContext(WidgetContext);

  const token = widgetContext.token;
  const setToken = widgetContext.setToken;
  const isFixedToken = widgetContext.hasDefaultToken;
  const data = getVolContext.data?.[SnapshotTypeEnum.EE]?.params?.data;

  const timestamp = getVolContext.timestamp[type];

  return (
    <ModelVolatilitySurfaceContext.Provider
      value={{ token, setToken, data, timestamp, isFixedToken }}
    >
      {children}
    </ModelVolatilitySurfaceContext.Provider>
  );
};
